import { render } from "./BuerArticle.vue?vue&type=template&id=3ac06567"
const script = {}

import "./BuerArticle.vue?vue&type=style&index=0&id=3ac06567&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__